import {Box, Select, TableCell, CircularProgress, MenuItem, Grid, ClickAwayListener, TextField} from '@mui/material'
import styled from '@emotion/styled'
import Paper from '@mui/material/Paper'
import {SectionTitle, InputTitleNormal} from '../common/TitleStyle'
import IconButton from '@mui/material/IconButton'
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn'
import Tooltip from '@mui/material/Tooltip'
import Switch from '@mui/material/Switch'
import PropTypes from 'prop-types'
import ToggleButton from '@mui/material/ToggleButton'
import Button from '@mui/material/Button'
import CustomBox from '../../components/common/CustomBox'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import AddCircleIcon from '@mui/icons-material/AddCircle'

export const StyledUserMgmt = styled('div')(({theme}) => ({
  marginLeft: theme.spacing(1)
}))

export const StyledGrid = styled(Grid)(() => ({
  maxWidth: '300px'
}))

export const StyledSelect = styled(Select)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.body1.fontSize,
  borderRadius: theme.spacing(0.5),
  height: '32px',
  width: 140
}))

export const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  fontSize: theme.typography.body1.fontSize
}))

export const InputTitle = styled('div', {shouldForwardProp: (prop) => prop !== 'isCompleted'})(
  ({theme, isCompleted}) => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: '6px',
    letterSpacing: '0.245536px',
    color: isCompleted ? theme.palette.hpAccentBlack : theme.palette.hpBase
  })
)
export const StyledTable = styled(Paper)(() => ({
  overflow: 'auto',
  marginTop: '8px',
  marginBottom: '8px'
}))
export const StyledTableCell = styled(TableCell)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  padding: '9px'
}))
export const StyledEmptyTableMessage = styled(TableCell)(({theme}) => ({
  // textAlign: 'center',
  padding: theme.spacing(4),
  color: theme.palette.hpAccentBlack,
  fontStyle: 'italic',
  fontSize: theme.typography.body1.fontSize
}))
export const StyledBox = styled(Box)(({theme}) => ({
  marginRight: '80px',
  color: theme.palette.hpAccentBlack
}))
export const InputError = styled(InputTitleNormal)(({theme}) => ({
  color: theme.palette.hpAccentRed,
  fontSize: theme.typography.subtitle1.fontSize,
  marginLeft: 0,
  maxWidth: '200px'
}))

export const InlineErrorWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.hpErrorRedLightest,
  borderRadius: theme.spacing(0.5),
  color: theme.palette.hpAccentRed,
  fontSize: theme.typography.subtitle1.fontSize,
  '& svg': {
    fontSize: theme.typography.h6.fontSize,
    flexShrink: 0,
    marginTop: '2px',
    color: theme.palette.hpAccentRed
  }
}))

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  color: 'inherit'
}))

export const UserSectionTitleButton = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== 'isCompleted'
})(({theme, selected}) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightSemibold,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: theme.typography.h5.lineHeight,
  letterSpacing: '0.25px',
  textTransform: 'none',
  marginTop: '16px',
  marginBottom: '16px',
  color: selected ? theme.palette.hpAccentBlack : theme.palette.hpPrimaryDark,
  border: 'none',
  '&.Mui-selected, &.Mui-selected:hover': {
    color: theme.palette.hpAccentBlack,
    backgroundColor: 'transparent'
  },
  '&:hover': {
    backgroundColor: 'transparent'
  },
  boxShadow: 'none'
}))

export const UserSectionTitle = styled(SectionTitle, {shouldForwardProp: (prop) => prop !== 'isCompleted'})(
  ({theme, isCompleted}) => ({
    marginTop: '16px',
    marginBottom: '16px',
    color: isCompleted ? theme.palette.hpAccentBlack : theme.palette.grey[700]
  })
)

export const Separator = styled('div')(({theme}) => ({
  alignSelf: 'center',
  color: theme.palette.hpAccentBlack,
  fontWeight: theme.typography.fontWeightMedium,
  marginTop: '12px'
}))

export const StyledDiv = styled('div')(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  fontSize: theme.typography.body1.fontSize
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryLightest
  }
}))

export const StyledDeleteIcon = styled(DoDisturbOnIcon)(({theme}) => ({
  color: theme.palette.hpAccentRedLight
}))

export const StyledToolTipIconButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.hpPrimary,
  padding: '0px',
  margin: '0px 0px 3px 3px'
}))

export const ToBeStyledTooltip = ({className, onClickAway, ...props}) => (
  <ClickAwayListener onClickAway={onClickAway}>
    <Tooltip {...props} classes={{tooltip: className}} />
  </ClickAwayListener>
)
ToBeStyledTooltip.propTypes = {
  className: PropTypes.any,
  onClickAway: PropTypes.func
}

export const StyledTooltip = styled(ToBeStyledTooltip)(({theme}) => ({
  borderRadius: '8px',
  fontFamily: 'Open Sans',
  lineHeight: theme.typography.h2.lineHeight,
  fontWeight: theme.typography.fontWeightSemibold,
  backgroundColor: theme.palette.grey[700]
}))

export const TemporaryToggle = styled((props) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({theme}) => ({
  width: '62px',
  height: '28px',
  padding: 2,
  '& .MuiSwitch-switchBase': {
    padding: 4,
    margin: 2,
    transitionDuration: '300ms',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&.Mui-checked': {
      transform: 'translate(26px, 0px)',
      color: theme.palette.hpWhite,
      '&:hover': {
        backgroundColor: 'transparent'
      },
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.hpAccentGreenVivid : theme.palette.hpAccentGreen,
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.palette.hpAccentGreenVivid,
      border: `6px solid ${theme.palette.hpWhite}`
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '20px',
    height: '20px',
    transform: 'translate(-2px, -1.7px)',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  '& .MuiSwitch-track': {
    height: '24px',
    width: '50px',
    borderRadius: 22 / 2,
    backgroundColor: theme.palette.grey[700],
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}))

export const StyledSpacedDiv = styled('div')(() => ({
  paddingLeft: '16px'
}))

export const FlexAlignCenterBox = styled(CustomBox)(() => ({
  display: 'flex',
  alignItems: 'center'
}))
export const StyledDateDiv = styled('div')(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  ':focus-visible': {
    outline: 'none'
  }
}))

export const StyledEndDateTextField = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    minHeight: '48px'
  }
}))

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  height: '40px'
}))

export const AddUserButton = styled(Button)(({theme}) => ({
  borderRadius: theme.spacing(0.5),
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightSemibold,
  fontSize: theme.typography.body1.fontSize,
  textTransform: 'none',
  padding: '4px 16px',
  height: '32px',
  whiteSpace: 'nowrap',
  '&.MuiButton-outlined': {
    borderColor: theme.palette.hpPrimary,
    color: theme.palette.hpPrimary,
    '&:hover': {
      backgroundColor: theme.palette.hpPrimaryLightest,
      borderColor: theme.palette.hpPrimary
    }
  },
  '&:disabled': {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.hpWhite
  }
}))

export const FlexSpaceBetweenBox = styled(CustomBox)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}))

export const FlexGapBox = styled(CustomBox)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center'
}))

export const StyledAddCircleIcon = styled(AddCircleIcon)(() => ({
  marginRight: '8px'
}))

export const VerticalMarginBox = styled(CustomBox)(({theme}) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2)
}))
